"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = _interopRequireDefault(require("react"));
var _Drawer = require("./Drawer.style");
var _useOnclickoutside = _interopRequireDefault(require("use-onclickoutside"));
const Drawer = _ref => {
  let {
    className = 'drawer',
    direction = 'left',
    open = false,
    zindex = 9999,
    children,
    onClose
  } = _ref;
  const drawerRef = _react["default"].useRef(null);
  const onClickOutsideHideOptions = event => {
    const target = event.target;
    const isDrawer = target.matches(".".concat(className));
    if (isDrawer) {
      onClose();
    }
  };
  (0, _useOnclickoutside["default"])(drawerRef, e => onClickOutsideHideOptions(e));
  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: open && (0, _jsxRuntime.jsx)(_Drawer.Components.Wrapper, (0, _extends2["default"])({
      className: className,
      zindex: zindex
    }, {
      children: (0, _jsxRuntime.jsx)(_Drawer.Components.Drawer, (0, _extends2["default"])({
        className: "".concat(open ? 'open' : ''),
        ref: drawerRef,
        open: open,
        zindex: zindex,
        direction: direction
      }, {
        children: children
      }))
    }))
  });
};
var _default = exports["default"] = Drawer;